import * as THREE from "three";

export function createScene() {
  const scene = new THREE.Scene();
  scene.background = null;
  return scene;
}
